import { readRefusal } from '@/api/api';

/** The code the server answers a reply with once the 360 no longer takes replies to its comments. */
const COMMENT_REPLIES_DISABLED_CODE = 'CommentRepliesDisabled';

/** True when a reply was refused because replies to the comments were turned off since the page was read. */
export const isCommentRepliesDisabledRefusal = (error: unknown): boolean =>
    readRefusal(error)?.code === COMMENT_REPLIES_DISABLED_CODE;
